module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-9cba06b8.png";